"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _removeSpaces = require("../../utils/removeSpaces");
var _generateLinks = require("../../utils/generateLinks");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SectorFooter = _ref => {
  let {
    socialLinksTitle,
    socialLinks,
    sectorFooterLinks,
    calloutLinks,
    Link,
    contentfulId
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const generateCalloutLinks = calloutLinks => {
    return calloutLinks.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        className: "ter-footer__callout callout",
        to: link?.url,
        rel: "noopener noreferrer",
        tabIndex: "0",
        Link: Link,
        target: typeof link?.external === "boolean" ? link?.external ? "_blank" : "_self" : null,
        ariaLabel: link?.external === true ? `Open ${link.title} in a new tab` : null
      }, link.icon && /*#__PURE__*/_react.default.createElement("img", {
        src: link?.icon,
        alt: link?.title + " icon",
        className: "callout__icon",
        image: link?.icon || null
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "callout__text"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "callout__title"
      }, link?.title, /*#__PURE__*/_react.default.createElement("span", {
        className: "callout__link-icon"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: "7",
        height: "12",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "callout link icon"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M.31 10.059l4.125-4.125L.311 1.81A1.059 1.059 0 111.81.31l4.88 4.88a1.059 1.059 0 010 1.5l-4.88 4.878a1.059 1.059 0 01-1.5 0 1.081 1.081 0 010-1.51z",
        fill: "currentColor"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "callout__subtitle"
      }, link?.subTitle))));
    });
  };
  const generateFooterSectorLinks = (links, Link) => {
    return links.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement("nav", {
        className: "ter-footer__section ter-footer__section--menu",
        key: index
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "ter-footer__footer-menu"
      }, link && /*#__PURE__*/_react.default.createElement("li", {
        className: "footer-menu__title"
      }, link.title), link.menuLinks && link.menuLinks.map((link, index) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "footer-menu__item",
          key: index
        }, (0, _generateLinks.generateSingleLinkFunctionless)(link, "footer-menu__link", index, Link));
      })));
    });
  };
  const generateFooterSocialLinks = socialLinks => {
    return socialLinks && socialLinks?.map((socialLink, index) => {
      const {
        icon,
        link,
        siteName
      } = socialLink;
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "footer-menu__item",
        key: index
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: mouse ? "ter-footer__social-link" : "ter-footer__social-link tagFocus",
        key: index,
        href: link.url,
        target: link.external === false ? "_self" : "_blank",
        rel: link.external === false ? "" : "noopener noreferrer",
        "aria-label": `${siteName ? `Visit us on ${siteName}` : ""}`,
        tabIndex: "0"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "ter-footer__social-link-icon",
        src: (0, _removeSpaces.removeSpaces)(icon.url),
        alt: icon.altText ? icon.altText : ""
      })));
    });
  };
  const returnSocialMenu = () => {
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: `ter-footer__section-social 
          ter-footer__section-social--${sectorFooterLinks?.length}
        `
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "ter-footer__footer-menu ter-footer__footer-menu--social"
    }, socialLinksTitle && /*#__PURE__*/_react.default.createElement("li", {
      className: "footer-menu__title"
    }, socialLinksTitle), generateFooterSocialLinks(socialLinks)));
  };
  let markup = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const groupedSocialMenu = sectorFooterLinks?.length === 4 ? false : true;
  if (calloutLinks || sectorFooterLinks) {
    markup = /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-footer__grid-wrapper-top"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: `ter-footer__sector-footer ${groupedSocialMenu ? "ter-footer__grouped-social-menu" : "ter-footer__ungrouped-social-menu"}`
    }, /*#__PURE__*/_react.default.createElement("nav", {
      className: "ter-footer__section-callouts"
    }, calloutLinks && generateCalloutLinks(calloutLinks)), /*#__PURE__*/_react.default.createElement("section", {
      className: "ter-footer__section-wrapper"
    }, sectorFooterLinks && generateFooterSectorLinks(sectorFooterLinks, Link), groupedSocialMenu && returnSocialMenu()), !groupedSocialMenu && returnSocialMenu()));
  }
  return markup;
};
var _default = SectorFooter;
exports.default = _default;